'use client';

import React, { useState, useEffect } from 'react';

interface CountdownRevealProps {
  onComplete: () => void;
}

export default function CountdownReveal({ onComplete }: CountdownRevealProps) {
  const [count, setCount] = useState(3);
  const [phase, setPhase] = useState<'counting' | 'reveal'>('counting');

  useEffect(() => {
    if (count > 0) {
      const timer = setTimeout(() => setCount((c) => c - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setPhase('reveal');
      const timer = setTimeout(() => onComplete(), 800);
      return () => clearTimeout(timer);
    }
  }, [count, onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="text-center bounce-in">
        {phase === 'counting' ? (
          <>
            <div className="relative w-32 h-32 mx-auto mb-4">
              <svg className="w-32 h-32 -rotate-90" viewBox="0 0 100 100">
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="rgba(255,255,255,0.2)"
                  strokeWidth="6"
                />
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  fill="none"
                  stroke="white"
                  strokeWidth="6"
                  strokeLinecap="round"
                  className="countdown-ring"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-6xl font-800 text-white font-tabular">{count}</span>
              </div>
            </div>
            <p className="text-white/80 text-xl font-600">Preparándose para revelar...</p>
          </>
        ) : (
          <div className="bounce-in">
            <div className="text-8xl mb-4">🎉</div>
            <p className="text-white text-2xl font-800">¡A revelar!</p>
          </div>
        )}
      </div>
    </div>
  );
}